import Keycloak from 'keycloak-js';
import apiClient from '@/plugins/api-client';
import { getSubdomain } from '@/helpers/util';

let keycloakInstance = null;
const timeLeftBeforeRefresh = 60 * 15;

export const initKeycloak = async () => {
  const config = await getKeycloakConfig();
  keycloakInstance = new Keycloak(config);
  return keycloakInstance.init({ onLoad: 'login-required' });
};

const getKeycloakConfig = async () => {
  try {
    const response = await apiClient.get(`portal/${getSubdomain()}/realm`);

    return response.data.data;
  } catch (err) {
    console.log(err);
  }
};

/**
 * @returns {Promise<Keycloak>}
 */
export const getKeycloak = async () => {
  if (keycloakInstance === null) {
    throw Error('Keycloak instance used before it was initialized.');
  }

  try {
    await keycloakInstance.updateToken(timeLeftBeforeRefresh);
  } catch (error) {
    console.log(error);
    throw Error('Failed to refresh token');
  }
  return keycloakInstance;
};
